import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Grid, Box, Image, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import SuitcaseSVG from '../../assets/images/dashboard/suitcase.svg';
import MemeSVG from '../../assets/images/dashboard/meme.svg';
import MoneySVG from '../../assets/images/dashboard/money.svg';
import ArrowLeftBlueSVG from '../../assets/images/icons/arrow-left-blue.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

const Title = ({ props }) => {

    /*
        - defaultData
    */
    const [dashboardBoxesData, setDashboardBoxesData] = React.useState('loading');

    React.useEffect(() => {
        if (props.dashboardBoxesData.status === 200) {
            setDashboardBoxesData(props.dashboardBoxesData.data);
        }
    }, [props]);

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12 md-6 xl-3'>
                        <Box
                            className={`d-flex justify-content-center p-lg bg-white border-solid border-light rounded-lg shadow-dark-hover`}
                            ms={{
                                gap: 'var(--sizing-xxl)',
                                '&:hover img': {
                                    opacity: '1'
                                }
                            }}>
                            <Box
                                className={`d-flex align-content-center`}>
                                <Image
                                    src={SuitcaseSVG}
                                    ms={{
                                        width: '56px',
                                        height: 'auto',
                                        objectFit: 'contain'
                                    }} />
                            </Box>
                            <Box>
                                <Typography
                                    className={`text-primary`}
                                    component='h5'>
                                    {dashboardBoxesData !== 'loading' && `${dashboardBoxesData.reservesCount} خرید`}
                                    {dashboardBoxesData === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                    }
                                </Typography>
                                <Typography
                                    className={`d-block`}
                                    component='small'>
                                    تعداد خریدها در سال گذشته
                                </Typography>
                                <Box
                                    className={`my-xl mb-0`} />
                                <RouterLink
                                    to='/reserve'>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center`}>
                                        <Typography
                                            className={`text-primary`}>
                                            سوابق رزرو
                                        </Typography>
                                        <Image
                                            src={ArrowLeftBlueSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px',
                                                opacity: '0',
                                                transition: '0.25s'
                                            }} />
                                    </Box>
                                </RouterLink>
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        size='col-12 md-6 xl-3'>
                        <Box
                            className={`d-flex justify-content-center p-lg bg-white border-solid border-light rounded-lg shadow-dark-hover`}
                            ms={{
                                gap: 'var(--sizing-xxl)',
                                '&:hover img': {
                                    opacity: '1'
                                }
                            }}>
                            <Box
                                className={`d-flex align-content-center`}>
                                <Image
                                    src={MemeSVG}
                                    ms={{
                                        width: '56px',
                                        height: 'auto',
                                        objectFit: 'contain'
                                    }} />
                            </Box>
                            <Box>
                                <Typography
                                    className={`text-primary`}
                                    component='h5'>
                                    {dashboardBoxesData !== 'loading' && `${dashboardBoxesData.countOfSubsetMembers} نفر`}
                                    {dashboardBoxesData === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                    }
                                </Typography>
                                <Typography
                                    className={`d-block`}
                                    component='small'>
                                    تعداد اعضای زیرمجوعه شما
                                </Typography>
                                <Box
                                    className={`my-xl mb-0`} />
                                <RouterLink
                                    to='/user/member'>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center`}>
                                        <Typography
                                            className={`text-primary`}>
                                            لیست اعضا
                                        </Typography>
                                        <Image
                                            src={ArrowLeftBlueSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px',
                                                opacity: '0',
                                                transition: '0.25s'
                                            }} />
                                    </Box>
                                </RouterLink>
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        size='col-12 md-6 xl-3'>
                        <Box
                            className={`d-flex justify-content-center p-lg bg-white border-solid border-light rounded-lg shadow-dark-hover`}
                            ms={{
                                gap: 'var(--sizing-xxl)',
                                '&:hover img': {
                                    opacity: '1'
                                }
                            }}>
                            <Box
                                className={`d-flex align-content-center`}>
                                <Image
                                    src={MoneySVG}
                                    ms={{
                                        width: '56px',
                                        height: 'auto',
                                        objectFit: 'contain'
                                    }} />
                            </Box>
                            <Box>
                                <Typography
                                    className={`text-primary`}
                                    component='h5'>
                                    {dashboardBoxesData !== 'loading' && `${(Math.floor(dashboardBoxesData.walletAmount) / 10).toLocaleString()} تومان`}
                                    {dashboardBoxesData === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                    }
                                </Typography>
                                <Typography
                                    className={`d-block`}
                                    component='small'>
                                    موجودی کیف پول شما
                                </Typography>
                                <Box
                                    className={`my-xl mb-0`} />
                                <RouterLink
                                    to='/finance/report'>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center`}>
                                        <Typography
                                            className={`text-primary`}>
                                            کیف پول
                                        </Typography>
                                        <Image
                                            src={ArrowLeftBlueSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px',
                                                opacity: '0',
                                                transition: '0.25s'
                                            }} />
                                    </Box>
                                </RouterLink>
                            </Box>
                        </Box>
                    </Grid.Item>
                    <Grid.Item
                        size='col-12 md-6 xl-3'>
                        <Box
                            className={`d-flex justify-content-center p-lg bg-white border-solid border-light rounded-lg shadow-dark-hover`}
                            ms={{
                                gap: 'var(--sizing-xxl)',
                                '&:hover img': {
                                    opacity: '1'
                                }
                            }}>
                            <Box
                                className={`d-flex align-content-center`}>
                                <Image
                                    src={MoneySVG}
                                    ms={{
                                        width: '56px',
                                        height: 'auto',
                                        objectFit: 'contain'
                                    }} />
                            </Box>
                            <Box>
                                <Typography
                                    className={`text-primary`}
                                    component='h5'>
                                    {dashboardBoxesData !== 'loading' && `${(Math.floor(dashboardBoxesData.creditAmount) / 10).toLocaleString()} تومان`}
                                    {dashboardBoxesData === 'loading' &&
                                        <Image
                                            className={`d-inline`}
                                            src={LoadingCustomSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                    }
                                </Typography>
                                <Typography
                                    className={`d-block`}
                                    component='small'>
                                    از مجموع کل اعتبار شما
                                </Typography>
                                <Box
                                    className={`my-xl mb-0`} />
                                <RouterLink
                                    to='/finance/settlement'>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center`}>
                                        <Typography
                                            className={`text-primary`}>
                                            اعتبار
                                        </Typography>
                                        <Image
                                            src={ArrowLeftBlueSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px',
                                                opacity: '0',
                                                transition: '0.25s'
                                            }} />
                                    </Box>
                                </RouterLink>
                            </Box>
                        </Box>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment >
    );

}

export default Title;